import { pluralize } from './pluralize';
export const toTitleCase = (str: string, plural?: boolean) => {
	return (plural ? pluralize(str || '') : str || '').replace(
		/\w\S*/g,
		(txt: string) => {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		}
	);
};
